import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';
import { currentQuestionBlockSelector } from 'selectors';
import BlockNavigationButton from './BlockNavigationButton';

class PreviousBlockButton extends Component {
  onClick = () => {
    const { getBlock, previousBlockId } = this.props;
    if (previousBlockId) {
      getBlock(previousBlockId);
    }
  };

  render() {
    const { previousBlockId } = this.props;
    const disabled = !previousBlockId;
    return (
      <BlockNavigationButton
        className="PreviousBlockButton"
        onClick={this.onClick}
        disabled={disabled}
      >
        Previous
      </BlockNavigationButton>
    );
  }
}

PreviousBlockButton.propTypes = {
  previousBlockId: PropTypes.string,
};

function mapStateToProps(state) {
  const block = currentQuestionBlockSelector(state);
  return {
    previousBlockId: block.previous_block_id,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getBlock: actions.getBlock,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(
  PreviousBlockButton
);



// WEBPACK FOOTER //
// ./src/Components/Pages/Survey/PreviousBlockButton.js